import React, { Component } from 'react';
import ReactTable from "react-table";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';

import * as Actions from '../store/actions';
import * as NoteActions from 'main/components/note/store/actions';
import QuestionScore from './QuestionScore';
import TabPanelButtons from 'main/components/TabPanelButtons';

import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded } from '@fuse';
import {
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    AppBar,
    Typography,
    Card,
    CardContent,
    Icon,
    Button,
    IconButton,
    Paper,
    Grid,
    Tabs,
    Tab,
} from '@material-ui/core';

const styles = theme => ({
    layoutRoot: {},
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200,
    },
    button: {
        margin: theme.spacing.unit,
    },

    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64,
        flex: 1
    },
    tabRoot: {
        height: 64,
        [theme.breakpoints.up('md')]: {
            minWidth: '144px'
        }
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
});

class QuizScore extends Component {
    state = {
        student_quiz_id: 0,
        current_tab: 0,
    }

    constructor(props) {
        super(props);

        this.state.student_quiz_id = this.props.match.params.student_quiz_id;
    }

    componentDidMount = () => {
        const { getStudentQuiz, getNoteList, getNextEventForContinueButton } = this.props;

        getStudentQuiz(this.state.student_quiz_id);

        if (this.props.auth.user.role === 'student') {
            const student_id = this.props.auth.user.data.role_info.link_id
            getNoteList('student_quiz', this.state.student_quiz_id);
            getNextEventForContinueButton(this.state.student_quiz_id, 1, student_id);
        }
    }

    handleChangeTab = (event, value) => {
        this.setState({
            current_tab: value
        });
    }

    generatePageContent = () => {
        const { classes, studentQuiz, quiz } = this.props;
        const { current_tab } = this.state;

        switch (current_tab) {
            case (0):
                {
                    return (
                        <Grid container>
                            <Grid item xs={6}>
                                <Grid container>
                                    <Grid item xs={4}>
                                        Quiz Name:
                                            </Grid>
                                    <Grid item xs={8}>
                                        {quiz.header.QuizName}
                                    </Grid>
                                    <Grid item xs={4}>
                                        Start Time:
                                            </Grid>
                                    <Grid item xs={8}>
                                        {studentQuiz.header.StartTime}
                                    </Grid>
                                    <Grid item xs={4}>
                                        End Time:
                                            </Grid>
                                    <Grid item xs={8}>
                                        {studentQuiz.header.EndTime}
                                    </Grid>
                                    <Grid item xs={4}>
                                        Attempt #:
                                            </Grid>
                                    <Grid item xs={8}>
                                        {studentQuiz.header.Attempt}/{quiz.header.MaxAttempt}
                                    </Grid>
                                    <Grid item xs={4}>
                                        Grade
                                            </Grid>
                                    <Grid item xs={8}>
                                        {Math.round(studentQuiz.header.Score).toFixed(1)}/{Math.round(quiz.header.MaxScore).toFixed(1)}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    );
                }

            case (1):
                {
                    return (
                        <React.Fragment>
                            <AppBar position="static">
                                <div className="p-16 pr-4 flex flex-row items-center justify-between">
                                    <Typography className="h1 pr-16" color="inherit">Question List</Typography>
                                </div>
                            </AppBar>
                            {quiz.questionList.map((question) => {
                                let studentQuestion = studentQuiz.studentQuestionList.filter((student_question) => student_question.question_id === question.header.question_id)[0];
                                if (typeof studentQuestion === 'undefined') {

                                    studentQuestion = {
                                        question_id: question.header.question_id,
                                        answer_id: 0,
                                        AnswerText: '',
                                        Score: 0.00,
                                        studentAnswerList: [],
                                    }
                                }

                                return (
                                    <QuestionScore
                                        key={question.header.question_id}
                                        question={question}
                                        studentQuestion={studentQuestion}
                                    />
                                );
                            })}
                        </React.Fragment>
                    );
                }

            default: { }
        }
    }

    render() {
        const { classes, studentQuiz, quiz, nextEvent, auth } = this.props;
        const { current_tab } = this.state;
        const page_content = this.generatePageContent();

        if (studentQuiz.header.student_quiz_id === 0) {
            return (<div>Loading...</div>);
        }

        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot
                }}
                header={
                    <div className="p-24">
                        <h4>
                            Quiz Score
                        </h4>
                    </div>
                }
                contentToolbar={
                    <div style={{ width: '100%', height: '100%' }}>
                        <Grid container>
                            <Grid item xs={6}>
                                <Tabs
                                    value={current_tab}
                                    onChange={this.handleChangeTab}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    classes={{
                                        root: classes.tabsRoot
                                    }}
                                    scrollable={true}
                                >
                                    <Tab
                                        classes={{
                                            root: classes.tabRoot
                                        }}
                                        label="Detail"
                                    />
                                    <Tab
                                        classes={{
                                            root: classes.tabRoot
                                        }}
                                        label="Answers"
                                    />
                                </Tabs>
                            </Grid>
                            <Grid item xs={6}>
                                <div className="flex items-center justify-end" style={{ height: '64px' }}>
                                    <TabPanelButtons
                                        component_name = {"quiz"}
                                        view_type      = {"detail"}
                                        largeLabel // hack to get course dashboard button on one line
                                        button_list    = {[
                                            {
                                                display:  "Back",
                                                type:     "back",
                                                onClick:  () => this.props.history.push(`/${this.props.prevEvent.EventType}/student/${this.props.prevEvent.company_calendar_event_id}`),
                                                disabled: !this.props.prevEvent,
                                                hidden: this.props.auth.user.role !== 'student',
                                            },
                                            {
                                                display: studentQuiz.header.NewUserAuthRole === 0 ? 'Course Dashboard' : 'Course Menu',
                                                type:    "back",
                                                onClick: () => this.props.history.push(`/course-dashboard/` + studentQuiz.header.company_calendar_course_id + '/' + studentQuiz.header.CourseUnscheduled),
                                                hidden: this.props.auth.user.role !== 'student',
                                                largeLabel: true
                                            },
                                            {
                                                display:  "Next",
                                                type:     "back",
                                                onClick:  () => this.props.history.push(`/${this.props.nextEvent.EventType}/student/${this.props.nextEvent.company_calendar_event_id}`),
                                                disabled: !this.props.nextEvent,
                                                hidden: this.props.auth.user.role !== 'student',
                                            },
                                            {
                                                display:  "Back",
                                                type:     "back",
                                                onClick:  () => this.props.history.push(`/quiz/edit/` + this.props.quiz.header.quiz_id),
                                                disabled: !this.props.nextEvent,
                                                hidden: this.props.auth.user.role === 'student',
                                            },
                                        ]}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                }
                content={
                    <div className="p-24">
                        {page_content}
                    </div>
                }
            />
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getStudentQuiz: Actions.getStudentQuiz,
        getNoteList: NoteActions.getNoteList,
        getNextEventForContinueButton: Actions.getNextEventForContinueButton
    }, dispatch);
}

function mapStateToProps({ quizApp, auth }) {
    return {
        auth,
        studentQuiz: quizApp.quizScore.studentQuiz,
        quiz: quizApp.quizzes.currentQuiz,
        nextEvent: quizApp.quizScore.nextEvent,
        prevEvent: quizApp.quizScore.prevEvent
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(QuizScore)));


// WEBPACK FOOTER //
// src/main/content/quiz/quizScore/QuizScore.js